const routes = [
    {
        name: 'dashboard',
        path: '/dashboard',
        component: () => {
            return import('@/views/report/Index');
        },
        meta: { stickyTopBar: true, title: 'Analytics', breadcrumbName: 'Analytics', actions: true },
    },
];

export default routes;
